'use client';
import * as Styled from './styled';
import { Card } from '@/ui/primatives';

import { colors } from '@/styles';

import BranchFileVersionSelect, { BranchFileVersionSelectProps } from '@/components/BranchFileVersionSelect';

type FileVersionSelectProps = BranchFileVersionSelectProps & {
  label?: string;
};

const FileVersionSelect: React.FC<FileVersionSelectProps> = ({
  label,
  repository,
  initialBranch,
  initialEntry,
  initialEntriesResponse,
  initialBranchesResponse,
  initialVersion,
  onChange,
}) => {
  return (
    <Styled.FileVersionSelect>
      <h5>{label}</h5>
      <Card stretch style={{ background: colors.secondary.lightGray1 }}>
        <BranchFileVersionSelect
          repository={repository}
          initialBranch={initialBranch}
          initialBranchesResponse={initialBranchesResponse}
          initialEntry={initialEntry}
          initialEntriesResponse={initialEntriesResponse}
          initialVersion={initialVersion}
          onChange={onChange}
        />
      </Card>
    </Styled.FileVersionSelect>
  );
};

export default FileVersionSelect;
